import React from 'react';
import {Button} from 'components';
import {config} from 'helpers';
import {RootState} from 'store';
import {Announcement} from './announcement';
import css from './announcement.module.scss';

export class Update_2024_12_26 extends Announcement {
  eligible(state: RootState) {
    return !state.settings.announcements?.[this.constructor.name] && config.sw;
  }

  render() {
    return (
      <>
        <h1>Lists</h1>
        <p>Added a completely new 'Lists' functionality. You can now create multiple Lists to manage and organize your life. This may include, Shopping list, Activity list, Reading/Watching list, Packing list, Wish list, Projects, Ideas, To-Dos, etc.</p>
        <p className={css.footer}>
          <Button onClick={this.props.decline}>
            {this.props.isLast ? 'close' : 'next'}
          </Button>
        </p>
      </>
    );
  }
}
